import { useAsync, useMountEffect } from "@react-hookz/web";

import { detectAdBlock } from "shared/lib/ad-block";
import { isExternalScriptsDisabled } from "shared/lib/utils";

export function useDetectAdBlock() {
  const [state, { execute }] = useAsync(async () => {
    if (isExternalScriptsDisabled("ad-block")) return true;
    const hasAdBlock = await detectAdBlock();
    return hasAdBlock;
  });
  useMountEffect(execute);
  return state;
}
